import React, { useEffect, useState } from 'react'
import './About.css'
import { AiOutlineMail, AiOutlinePlus } from 'react-icons/ai'
import {  FaPaintBrush, FaShareAlt, } from 'react-icons/fa'
import { MdOutlineMonitor } from 'react-icons/md'
import choose from '../../Assets/choose.jpg'
import member1 from '../../Assets/avatar1.jpg'
import member2 from '../../Assets/avatar2.jpg'
import member3 from '../../Assets/avatar3.jpg'
import member4 from '../../Assets/avatar4.jpg'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'

const About = () => {
    // const services = [
    //     {
    //         icon:()=><MdOutlineMonitor className='icon'/>,
    //         title:'Digital Solution',
    //         content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti, reiciendis.'
    //     },
    //     {
    //         icon:()=><FaPaintBrush className='icon'/>,
    //         title:'Creative Work',
    //         content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti, reiciendis.'
    //     },
    //     {
    //         icon:()=><FaShareAlt className='icon'/>,
    //         title:'Digital Solution',
    //         content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti, reiciendis.'
    //     }
    // ]

    // const speciality = [
    //     'Brand Identity',
    //     'Web Design and UI',
    //     'Development and CMS',
    //     'Mutual Fund Screened'
    // ]

    // const member = [
    //     {
    //         avatar:()=>member1,
    //         name:'John Doe',
    //         designation:'Website Developer'
    //     },
    //     {
    //         avatar:()=>member2,
    //         name:'John Doe',
    //         designation:'App Developer'
    //     },
    //     {
    //         avatar:()=>member3,
    //         name:'John Doe',
    //         designation:'UI/UX Designer'
    //     },
    // ]

    // const testimonial = [
    //     {
    //         review: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vel recusandae sit iste cumque animi sunt repudiandae, corrupti sapiente atque molestias!',
    //         img: ()=>member1,
    //         name:'John Doe',
    //         designation:'Web Developer'
    //     },
    //     {
    //         review: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vel recusandae sit iste cumque animi sunt repudiandae, corrupti sapiente atque molestias!',
    //         img: ()=>member2,
    //         name:'John Doe',
    //         designation:'Web Developer'
    //     },
    //     {
    //         review: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vel recusandae sit iste cumque animi sunt repudiandae, corrupti sapiente atque molestias!',
    //         img: ()=>member3,
    //         name:'John Doe',
    //         designation:'Web Developer'
    //     },
    //     {
    //         review: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vel recusandae sit iste cumque animi sunt repudiandae, corrupti sapiente atque molestias!',
    //         img: ()=>member4,
    //         name:'John Doe',
    //         designation:'Web Developer'
    //     },
    // ]

    const [page,setPage] = useState(1);

  return (
    <>
    <Header/>
    <div className="about">
        {/* <div className="about-header">
            <h2>About the <span>Studio</span></h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic labore atque nisi! Dolore, reiciendis deleniti eaque dicta ipsum libero laborum!</p>
        </div> */}
        <div className="history">
            <div className="left">
                <h3>Our Story</h3>
            </div>
            <div className="right">
            <p> In fall of 2022, I had finished my first year at DTU and noticed the lack of an online community on campus. There were more than 3,000 of us in first year, with so much diversity and yet we failed to communicate with each other. <br/><br/>I felt the need of an online community, hence I set out to create Bubbl, a platform that facilitates authentic conversations among students in the community.</p>
                <h5>Kaustubh Chaukiyal</h5>
                <p>Founder & CEO</p>
            </div>
        </div>
        {/* <div className="services">
            {
                services.map((e,i)=>(
                    <div className="service" key={i}>
                        {e.icon()}
                        <h4>{e.title}</h4>
                        <p>{e.content}</p>
                    </div>
                ))
            }
        </div>
        <div className="choose">
            <div className="left">
                <h3>Why Choose Us</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis cupiditate iusto neque vel rem sint nulla velit totam quas similique?</p>
                <ul>
                    {
                        speciality.map((e,i)=>(
                            <li key={i}><AiOutlinePlus/>{e}</li>
                        ))
                    }
                </ul>
            </div>
            <div className="right">
                <div className='box'><img src={choose} alt="" /></div>
            </div>
        </div>
        <div className="members">
            <div className="heading">
                <h3>Creative Member</h3>
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Alias, ipsum sed assumenda sint error voluptas!</p>
            </div>
            <div className="team">
                {
                    member.map((e,i)=>(
                        <div className="box" key={i}>
                            <img src={e.avatar()} alt="" />
                            <div className="content">
                                <h4>{e.name}</h4>
                                <h6>{e.designation}</h6>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
        <div className="testimonials">
            <div className="heading">
                <h6>Latest Service</h6>
                <h3>Client Say About Us</h3>
            </div>
            <div className="reviews">
                {
                    testimonial.map((e,i)=>(
                        <div className="review" style={{
                            left:`${(i-page+1)*100}%`,
                        }}>
                            <p>{e.review}</p>
                            <div className="person">
                                <img src={e.img()} alt="" />
                                <div className="content">
                                    <h5>{e.name}</h5>
                                    <h6>{e.designation}</h6>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
            <div className="pagination">
                {
                    (page>1)?
                    <button onClick={()=>setPage(page-1)}>{'<'}</button>
                    :""
                }
                <button>{page}</button>
                {
                    (page<testimonial.length)?
                    <button onClick={()=>setPage(page+1)}>{'>'}</button>
                    :''
                }
            </div>
        </div> */}
    </div>
    <Footer/>
    </>
  )
}

export default About